<template>
  <CommonDialog
    v-if="isAddPaymentModalOpen"
    :isDialogOpened="isAddPaymentModalOpen"
    class="mt-2"
    width="500"
    @handleCloseDialog="toggleModal && toggleModal(false)"
  >
    <v-card class="px-1 pb-8">
      <v-card-title class="d-flex justify-end">
        <v-btn
          :disabled="isCreateAccountPending"
          icon
          @click="toggleModal && toggleModal(false)"
        >
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form
        v-if="!selectedOrg.processingFeeSubscription"
        ref="form"
        v-model="isFormValid"
      >
        <v-card-text>
          <h2
            class="add-payment-modal__heading text-center secondary--text mb-8"
          >
            {{ $t("team_registration.add_payment") }}
          </h2>
          <v-select
            :items="paymentProviders"
            item-text="name"
            item-value="value"
            v-model="paymentProvider"
            :placeholder="$t('team_registration.select_payment_provider')"
            outlined
            class="add-payment-modal__payment-provider-select rounded-lg"
            :rules="[rules.paymentProvider]"
          ></v-select>
          <v-text-field
            v-model="email"
            :label="$t('team_registration.type_email')"
            :rules="[rules.email]"
            class="add-payment-modal__payment-provider-input rounded-lg"
            color="#aab0bc"
            flat
            outlined
            solo
          />
          <v-text-field
            v-if="paymentProvider === PaymentProvidersTypes.FLUIDPAY"
            v-model="fluidpayPublicKey"
            :label="$t('team_registration.type_fluidpay_public_key')"
            :rules="[rules.fluidpayPublicKey]"
            class="add-payment-modal__payment-provider-input rounded-lg"
            color="#aab0bc"
            flat
            outlined
            solo
          />
          <v-text-field
            v-if="paymentProvider === PaymentProvidersTypes.FLUIDPAY"
            v-model="fluidpayPrivateKey"
            :label="$t('team_registration.type_fluidpay_private_key')"
            :rules="[rules.fluidpayPrivateKey]"
            class="add-payment-modal__payment-provider-input rounded-lg"
            color="#aab0bc"
            flat
            outlined
            solo
          />
          <div class="d-flex">
            <div style="width: 50%">
              <div class="fee-description">Processor Fee</div>
              <div>
                <v-tooltip :bottom="true" nudge-left="85" nudge-top="10">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <div class="learn">Learn More</div>
                    </span>
                  </template>
                  <div class="processor-tooltip">
                    Payment processors charge processing fees (ex. 2.9% + $0.70
                    per transaction). Input the processing fee you get charged.
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-text-field
              v-model="feePrice"
              class="payment-left-input"
              dense
              flat
              outlined
              prepend-inner-icon="mdi-currency-usd"
              solo
              style="width: 20%; text-align: right"
              type="number"
            />
            <v-text-field
              v-model="feePercentage"
              append-icon="mdi-percent-outline"
              class="payment-right-input"
              dense
              flat
              outlined
              solo
              style="width: 10%; text-align: right"
              type="number"
            />
          </div>
          <div
            v-if="
              selectedOrg.processingFeeInCents ||
                selectedOrg.processingFeePerMil
            "
            class="d-flex"
          >
            <div style="width: 50%">
              <div class="fee-description">TeamBot Fee</div>
              <div>
                <v-tooltip :bottom="true" nudge-left="85" nudge-top="10">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <div class="learn">Learn More</div>
                    </span>
                  </template>
                  <div class="processor-tooltip">
                    TeamBot charges a small fee to process payments
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-text-field
              :value="convertCentsToDollars(selectedOrg.processingFeeCents)"
              class="payment-left-input"
              dense
              disabled
              flat
              outlined
              prepend-inner-icon="mdi-currency-usd"
              solo
              style="width: 20%; text-align: right"
              type="number"
            />
            <v-text-field
              :value="convertPerMilToPercent(selectedOrg.processingFeePerMil)"
              append-icon="mdi-percent-outline"
              class="payment-right-input"
              dense
              disabled
              flat
              outlined
              solo
              style="width: 10%; text-align: right"
              type="number"
            />
          </div>
          <v-divider />
          <div class="d-flex mt-4">
            <div style="width: 50%">
              <div class="fee-description">Total</div>
              <div>
                <v-tooltip :bottom="true" nudge-left="85" nudge-top="10">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <div class="learn">Learn More</div>
                    </span>
                  </template>
                  <div class="processor-tooltip">
                    This is the total charged to either the customer, or the
                    club for transactions. You can decide whether to absorb
                    these costs, or let your team pay them at checkout for each
                    fee.
                  </div>
                </v-tooltip>
              </div>
            </div>
            <v-text-field
              :value="
                (
                  parseFloat(feePrice) +
                  parseFloat(
                    convertCentsToDollars(selectedOrg.processingFeeCents)
                  )
                ).toFixed(2)
              "
              class="payment-left-input"
              dense
              disabled
              flat
              outlined
              prepend-inner-icon="mdi-currency-usd"
              solo
              style="width: 20%; text-align: right"
              type="number"
            />
            <v-text-field
              :value="
                parseFloat(feePercentage) +
                  parseFloat(
                    convertPerMilToPercent(selectedOrg.processingFeePerMil)
                  )
              "
              append-icon="mdi-percent-outline"
              class="payment-right-input"
              dense
              disabled
              flat
              outlined
              solo
              style="width: 10%; text-align: right"
              type="number"
            />
          </div>
          <!--          <v-text-field-->
          <!--            v-model.trim="feePercentage"-->
          <!--            type="number"-->
          <!--            @paste.prevent-->
          <!--            :label="$t('team_registration.fee_percentage')"-->
          <!--            solo-->
          <!--            flat-->
          <!--            outlined-->
          <!--            class="add-payment-modal__payment-provider-input rounded-lg"-->
          <!--            color="#aab0bc"-->
          <!--            :rules="[rules.feePercentage]"-->
          <!--          />-->
          <!--          <v-text-field-->
          <!--            v-model.trim="feePrice"-->
          <!--            type="number"-->
          <!--            @paste.prevent-->
          <!--            :label="$t('team_registration.fee_price')"-->
          <!--            solo-->
          <!--            flat-->
          <!--            outlined-->
          <!--            class="add-payment-modal__payment-provider-input rounded-lg"-->
          <!--            color="#aab0bc"-->
          <!--            :rules="[rules.feePrice]"-->
          <!--          />-->
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <CommonButton
            :disabled="isCreateAccountPending"
            :label="$t('common.cancel')"
            class="px-4"
            color="#fff"
            width="100"
            @handleClick="toggleModal && toggleModal(false)"
          />
          <CommonButton
            :label="$t('team_registration.use_as_payment')"
            :loading="isCreateAccountPending"
            class="px-4"
            not-capitalize
            width="100"
            @handleClick="handleCreatePaymentAccount"
          />
        </v-card-actions>
      </v-form>
      <div v-else></div>
    </v-card>
  </CommonDialog>
</template>

<script>
import CommonButton from "../common/CommonButton";
import CommonDialog from "../common/dialog/CommonDialog";
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions, mapGetters } from "vuex";
import {
  PaymentProvidersNames,
  PaymentProvidersTypes
} from "../enums/PaymentProvidersTypes";
import { RegExps } from "../enums/RegExps";
import { i18n } from "@/plugins/i18n";
import GetterTypes from "@/store/GetterTypes";

export default {
  name: "AddPaymentModal",
  components: {
    CommonDialog,
    CommonButton
  },
  props: {
    isAddPaymentModalOpen: {
      type: Boolean,
      required: true
    },
    toggleModal: {
      type: Function,
      required: true
    },
    paymentsAccountsChange: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    paymentProviders: [
      {
        name: PaymentProvidersNames.FLUIDPAY,
        value: PaymentProvidersTypes.FLUIDPAY
      },
      {
        name: PaymentProvidersNames.PAYPAL,
        value: PaymentProvidersTypes.PAYPAL
      }
    ],
    PaymentProvidersTypes,
    isFormValid: false,
    paymentProvider: PaymentProvidersTypes.PAYPAL,
    email: "",
    fluidpayPrivateKey: "",
    fluidpayPublicKey: "",
    feePrice: 0,
    feePercentage: 0,
    isCreateAccountPending: false,
    orgHasProcessingSubscription: false,
    rules: {
      paymentProvider: value =>
        !!value || i18n.tc("validation.field_is_required"),
      email: value => {
        if (!value || !value.match(RegExps.EMAIL)) {
          return i18n.tc("validation.invalid_email");
        } else {
          return true;
        }
      },
      fluidpayPublicKey: value =>
        !!value?.match(RegExps.FLUIDPAYPUBLICKEY) ||
        i18n.tc("validation.invalid_fluidpay_public_key"),
      fluidpayPrivateKey: value =>
        !!value?.match(RegExps.FLUIDPAYPRIVATEKEY) ||
        i18n.tc("validation.invalid_fluidpay_private_key"),
      feePercentage: value =>
        value <= 100 || i18n.tc("validation.max_100_percent"),
      feePrice: value => {
        return (
          (value && Number.parseFloat(value)?.toFixed(2)) <= 99999 ||
          i18n.tc("validation.max_99999_number")
        );
      }
    }
  }),

  computed: {
    ...mapGetters({
      selectedOrg: GetterTypes.GET_ORGANIZATION
    })
  },
  methods: {
    convertCentsToDollars(cents) {
      return cents ? (cents / 100).toFixed(2) : 0;
    },
    convertPerMilToPercent(perMil) {
      return perMil ? (perMil / 10).toFixed(1) : 0;
    },
    ...mapActions(ModuleTypes.TEAM_REGISTRATION, [
      "createPaymentAccount",
      "createStripeAccount",
      "createStripeOnboarding",
      "createPayPalAccount"
    ]),

    handleCreatePaymentAccount() {
      this.$refs.form.validate();
      if (this.isFormValid) {
        const body = {
          paymentProviderName: this.paymentProvider,
          fluidpayPublicKey: this.fluidpayPublicKey,
          fluidpayPrivateKey: this.fluidpayPrivateKey,
          email: this.email,
          feeInPermile: +this.feePercentage > 0 ? +this.feePercentage * 10 : 0,
          feeInCents: +this.feePrice > 0 ? +this.feePrice * 100 : 0
        };
        this.isCreateAccountPending = true;
        this.createPaymentAccount({
          organizationId: this.selectedOrg.id,
          body,
          successCallback: ({ data }) => {
            const { STRIPE, PAYPAL, FLUIDPAY } = PaymentProvidersTypes;
            if (this.paymentProvider === STRIPE) {
              this.createStripeAccount({
                paymentAccountId: data.id,
                successCallback: ({ data }) => {
                  this.createStripeOnboarding({
                    stripeAccountId: data,
                    returnPath: this.$route.fullPath,
                    successCallback: ({ url }) => {
                      window.open(url, "_parent");
                      this.isCreateAccountPending = false;
                    }
                  });
                }
              });
            } else if (this.paymentProvider === FLUIDPAY) {
              this.fluidpayPrivateKey = "";
              this.fluidpayPublicKey = "";
              this.isCreateAccountPending = false;
              this.toggleModal && this.toggleModal(false);
              this.paymentsAccountsChange && this.paymentsAccountsChange(data);
            } else if (this.paymentProvider === PAYPAL) {
              this.createPayPalAccount({
                email: this.email,
                paymentAccountId: data.id,
                successCallback: ({ paymentsAccounts }) => {
                  this.isCreateAccountPending = false;
                  this.toggleModal && this.toggleModal(false);
                  this.paymentsAccountsChange &&
                    this.paymentsAccountsChange(paymentsAccounts);
                }
              });
            }
            this.email = "";
            this.feePrice = 0;
            this.feePercentage = 0;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.processor-tooltip {
  width: 300px;
}
.fee-description {
  font-size: 14px;
  font-weight: 500;
}
.learn {
  margin-top: -6px;
  font-size: 12px;
  font-weight: 300;
  color: #1f97ff;
  cursor: pointer;
}
.add-payment-modal__heading {
  font-size: 27px;
  font-weight: var(--font-weight-semi-bold);
}

.add-payment-modal__payment-provider-select >>> .v-input__slot,
.add-payment-modal__payment-provider-input >>> .v-input__slot {
  margin-bottom: 2px;
}

.add-payment-modal__payment-provider-select >>> .v-input__slot {
  min-height: 40px;
}

.add-payment-modal__payment-provider-input >>> .v-input__slot {
  min-height: 48px;
}

.add-payment-modal__payment-provider-input >>> .v-label {
  color: #aab0bc !important;
}

.add-payment-modal__payment-provider-select >>> .v-input__append-inner {
  margin: auto 0;
}

.add-payment-modal__payment-provider-select >>> fieldset {
  border-color: var(--grey-color) !important;
}

.add-payment-modal__payment-provider-select >>> .v-text-field__details,
.add-payment-modal__payment-provider-input >>> .v-text-field__details {
  margin-bottom: 2px;
}
</style>
<style>
.payment-right-input.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.payment-left-input.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
.v-text-field.v-text-field--enclosed .v-text-field__details {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.payment-left-input.v-input__control.v-input__slot.v-input__prepend-inner.vinput__icon.v-input__icon--prepend-inner.v-icon {
  margin-left: -12px;
}

.payment-right-input.v-text-field.v-text-field--solo .v-input__control input,
.payment-left-input.v-text-field.v-text-field--solo .v-input__control input {
  text-align: end;
}
</style>
